/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class MaterialType.
* @enum {}
* @readonly
*/
export default class MaterialType {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 3
         * @const
         */
        "3" = 3;

    
        /**
         * value: 4
         * @const
         */
        "4" = 4;

    
        /**
         * value: 5
         * @const
         */
        "5" = 5;

    
        /**
         * value: 6
         * @const
         */
        "6" = 6;

    
        /**
         * value: 7
         * @const
         */
        "7" = 7;

    
        /**
         * value: 8
         * @const
         */
        "8" = 8;

    
        /**
         * value: 9
         * @const
         */
        "9" = 9;

    
        /**
         * value: 10
         * @const
         */
        "10" = 10;

    
        /**
         * value: 11
         * @const
         */
        "11" = 11;

    
        /**
         * value: 12
         * @const
         */
        "12" = 12;

    
        /**
         * value: 13
         * @const
         */
        "13" = 13;

    
        /**
         * value: 14
         * @const
         */
        "14" = 14;

    
        /**
         * value: 15
         * @const
         */
        "15" = 15;

    
        /**
         * value: 16
         * @const
         */
        "16" = 16;

    
        /**
         * value: 17
         * @const
         */
        "17" = 17;

    
        /**
         * value: 18
         * @const
         */
        "18" = 18;

    
        /**
         * value: 19
         * @const
         */
        "19" = 19;

    
        /**
         * value: 20
         * @const
         */
        "20" = 20;

    
        /**
         * value: 100
         * @const
         */
        "100" = 100;

    
        /**
         * value: 201
         * @const
         */
        "201" = 201;

    
        /**
         * value: 202
         * @const
         */
        "202" = 202;

    
        /**
         * value: 203
         * @const
         */
        "203" = 203;

    
        /**
         * value: 204
         * @const
         */
        "204" = 204;

    

    /**
    * Returns a <code>MaterialType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/MaterialType} The enum <code>MaterialType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

